import React from "react";
import { PageHeader } from "@/pages/About";
import { AlertTriangle } from "lucide-react";

const Disclaimer = () => (
  <div>
    <PageHeader eyebrow="Legal" title="Disclaimer" subtitle="Important information about the scope and limitations of WECH-RB certification." />
    <section className="wechr-section">
      <div className="wechr-container max-w-3xl space-y-5 text-sm leading-relaxed text-navy-800">
        <div className="flex items-start gap-3 rounded-xl border border-gold-500 bg-gold-100 p-4 text-gold-700">
          <AlertTriangle className="mt-0.5 h-5 w-5 shrink-0" />
          <p>WECH-RB DD Certification is based on document review only and does not involve an on-site audit, inspection, or physical verification of facilities.</p>
        </div>
        <p>Certification is issued based on the documents and information submitted by the applicant and assessed against the WECH-RB Code of Conduct. It represents a point-in-time assessment and does not guarantee ongoing conformance, legal compliance, or the absence of risk.</p>
        <p>The AI-assisted review provides a preliminary, advisory analysis only. It may not identify all gaps or risks, and it does not replace professional, legal, or regulatory advice.</p>
        <p>Buyers, partners, and other third parties should perform their own due diligence and not rely solely on a WECH-RB certificate when making business decisions.</p>
        <p>WECH-RB makes no warranties, express or implied, regarding the accuracy or completeness of any assessment, and disclaims liability to the fullest extent permitted by law.</p>
        <p className="text-[var(--wechr-muted-text)]">This document is provided for platform demonstration purposes and does not constitute legal advice.</p>
      </div>
    </section>
  </div>
);

export default Disclaimer;
